<template>
    <svg
        :width="size"
        :height="size"
        viewBox="0 0 24 24"
        :fill="color"
        xmlns="http://www.w3.org/2000/svg"
        :style="{ color }"
    >
        <path
            d="M18.276 23.2306C18.4477 23.2306 18.6195 23.2071 18.7912 23.1603C18.9629 23.1135 19.1268 23.0354 19.283 22.9261C19.5484 22.7388 19.7474 22.4968 19.8801 22.2002C20.0128 21.9035 20.048 21.5991 19.9855 21.2869L18.9317 14.9406L23.4982 10.3741C23.7324 10.1399 23.8846 9.87064 23.9548 9.56621C24.0251 9.26178 24.0134 8.96125 23.9197 8.66462C23.8104 8.35238 23.6309 8.09479 23.3811 7.89183C23.1313 7.68888 22.8503 7.56398 22.5381 7.51714L16.2855 6.60385L13.569 0.960134C13.4285 0.663507 13.2177 0.429328 12.9367 0.257597C12.6557 0.0858656 12.3435 0 12 0C11.6565 0 11.3443 0.0858656 11.0633 0.257597C10.7823 0.429328 10.5715 0.663507 10.431 0.960134L7.71452 6.60385L1.46195 7.51714C1.14971 7.56398 0.868693 7.69278 0.618902 7.90354C0.369111 8.1143 0.189573 8.368 0.0802899 8.66462C-0.0133817 8.96125 -0.0250906 9.26178 0.0451631 9.56621C0.115417 9.87064 0.267633 10.1399 0.501812 10.3741L5.0683 14.9406L4.0145 21.2869C3.95205 21.5991 3.98718 21.9035 4.11988 22.2002C4.25258 22.4968 4.45163 22.7388 4.71703 22.9261C4.87315 23.0354 5.03318 23.1135 5.1971 23.1603C5.36103 23.2071 5.53666 23.2306 5.724 23.2306C5.86451 23.2306 6.00502 23.2149 6.14553 23.1837C6.28603 23.1525 6.41873 23.0979 6.54363 23.0198L12 20.0926L17.433 23.0198C17.5735 23.0979 17.714 23.1525 17.8545 23.1837C17.995 23.2149 18.1355 23.2306 18.276 23.2306V23.2306ZM18.4868 21.8723L12 18.4065L5.51324 21.8723L6.59047 15.5495L6.75439 14.4957L1.46195 9.20323L8.76833 8.12601L9.26011 7.11904L12 1.42849L15.2083 8.12601L22.5381 9.20323L17.2456 14.4957L17.4095 15.5495L18.4868 21.8723Z"
        />
    </svg>
</template>

<script>
import VueTypes from 'vue-types';

export default {
    name: 'StarSVG',
    props: {
        size: VueTypes.number.isRequired,
        color: VueTypes.string.isRequired,
    },
};
</script>

<style></style>
